<template>
  <ul :class="{ 'module-tree': isRoot }">
    <li
      v-if="isRoot"
      class="root module-tree__branch module-tree__branch--module"
    >
      <a
        ><strong> {{ entity.name }}</strong></a
      >
    </li>
    <draggable
      :list="getChildren(entity)"
      :options="{ animation: 200 }"
      :tag="'ul'"
      @change="updateOrder"
    >
      <li
        v-for="(node, index) in getChildren(entity)"
        :key="index"
        :class="'module-tree__branch--' + node.entityType"
        class="module-tree__branch"
      >
        <!--            Expand button-->
        <button
          v-if="hasChildren(node)"
          @click="toggleBranch(node)"
          :aria-expanded="node.expanded ? 'true' : 'false'"
        >
          {{ node.expanded ? '-' : '+' }}
        </button>

        <!--           Edit url-->
        <a :class="{ 'empty-node': missingChildren(node) }" :href="node.editUrl"
          >{{ getLabel(node) }} ({{ node.order }})</a
        >
        |
        <template v-if="childEntityType(node)">
          <a :href="node.addChildUrl">Add {{ childEntityType(node) }}</a> |
        </template>
        <a :href="node.deleteUrl">Delete {{ node.entityType }}</a>

        <module-tree :branch="node" v-if="node.expanded"> </module-tree>
      </li>
    </draggable>
  </ul>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },

  props: ['branch'],

  data() {
    return {
      entity: this.branch,
      csrf: document.head.querySelector('meta[name="csrf-token"]').content,
    };
  },

  methods: {
    /**
     *  Updates the order of an entity
     * @param event
     */
    updateOrder(event) {
      const movedEvent = event.moved;
      const reorderUrl = movedEvent.element.reorderUrl;

      // The order column in FormEngine is 1-indexed, not 0-indexed
      const newIndex = movedEvent.newIndex + 1;

      // Send a request to the reorder URL
      const request = new XMLHttpRequest();
      request.open('POST', reorderUrl, true);
      request.setRequestHeader('X-CSRF-TOKEN', this.csrf);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded'
      );
      request.send(`order=${newIndex}`);
    },

    /**
     *  Toggles the nodes (closed or open)
     * @param node
     */
    toggleBranch(node) {
      node.expanded = !node.expanded;
    },

    /**
     *  Return the correct label foe the entity type we are dealing with
     * @param entity
     * @returns {*}
     */
    getLabel(entity) {
      switch (entity.entityType) {
        case 'module':
          return entity.name;
        case 'section':
        case 'page':
          return entity.title;
        case 'question':
          return entity.label;
        case 'option':
          return entity.text;
      }
    },
    /**
     * Returns the name of any possible child entity types
     * @param entity
     * @returns {string|null}
     */
    childEntityType(entity) {
      switch (entity.entityType) {
        case 'module':
          return 'section';
        case 'section':
          return 'page';
        case 'page':
          return 'question';
        case 'question':
          if (entity.type === 'QuestionGroup') {
            return 'child question';
          } else if (entity.canHaveOptions) {
            return 'option';
          }
          break;
        default:
          return null;
      }
    },
    /**
     * Get the child entity types for the current entity
     * @param entity
     * @returns {null|[]}
     */
    getChildren(entity) {
      switch (entity.entityType) {
        case 'module':
          return entity.sections;
        case 'section':
          return entity.pages;
        case 'page':
          return entity.questions;
        case 'question':
          if (entity.type === 'QuestionGroup') {
            return entity.childQuestions;
          } else {
            return entity.options;
          }
        default:
          return null;
      }
    },
    /**
     * Checks if an entity has any children
     * @param entity
     * @returns {boolean}
     */
    hasChildren(entity) {
      let childNodes = this.getChildren(entity);
      return childNodes && childNodes.length > 0;
    },

    /**
     * Checks if an entity which should have children is empty
     * @param entity
     * @returns {boolean}
     */
    missingChildren(entity) {
      return entity.addChildUrl && !this.hasChildren(entity);
    },
  },

  computed: {
    /**
     * Entity of type module is the root entity
     * @returns {boolean}
     */
    isRoot() {
      return this.entity.entityType === 'module';
    },
  },
};
</script>
<style scoped>
.module-tree > ul {
  margin-top: 0;
}

.empty-node {
  color: red;
}
</style>
